export default {"src":"/_next/static/media/Grass.d3782e5e.svg","height":49,"width":271,"blurWidth":0,"blurHeight":0};